var checkout_pricing = (function ($) {

    var $checkout_pricing;

    var _init = function () {
        $checkout_pricing = $('#checkout-pricing-details');

        if ($checkout_pricing.length > 0) {
            _init_discount_listeners();
            _init_discount_remove_listeners();
        }
    };

    var _init_discount_listeners = function() {
        var $discount_form = $('.discount-code-form');

        $discount_form.find('.discount-apply-button').on('click', function() {
            let data = {
                security: wc_checkout_params.apply_coupon_nonce,
                coupon_code: $checkout_pricing.find('input[name="coupon_code"]').val()
            }

            $.post({
                url: wc_checkout_params.wc_ajax_url.toString().replace('%%endpoint%%', 'apply_coupon'),
                data: data,
                success: function (message) {
                    $checkout_pricing.find('.woocommerce-error, .woocommerce-message').remove();

                    if (message) {
                        $discount_form.before(message);
                        $discount_form.slideUp();

                        _refresh_checkout_pricing();

                        $(document.body).trigger('applied_coupon_in_checkout', [data.coupon_code]);
                        $(document.body).trigger('update_checkout', {update_shipping_method: false});
                    }
                },
                dataType: 'html'
            });
        });

    }

    var _init_discount_remove_listeners = function() {
        $checkout_pricing.find('.remove-discount').on('click', _remove_discount);
    }

    var _refresh_checkout_pricing = function(e) {
        let data = {
            nonce: scriptData.vibe_eos_checkout_pricing_ajax_getPricingDetails_nonce,
            action: 'vibe_eos_checkout_pricing_ajax_getPricingDetails'
        }

        $.post(scriptData.ajaxURL, data, function(res) {
            if (res.success) {
                _set_totaling_html(res.html);
            }
        });
    };

    var _remove_discount = function(e) {
        e.preventDefault();

        var $this = $(this);
        var code   = $this.data('code');

        if (code) {
            let data = {
                nonce: scriptData.vibe_eos_checkout_pricing_ajax_removeDiscount_nonce,
                action: 'vibe_eos_checkout_pricing_ajax_removeDiscount',
                code: $this.data('code')
            };

            $.post(scriptData.ajaxURL, data, function(res) {
                if (res.success) {
                    _set_totaling_html(res.html);
                }
            });
        }
    };

    var _set_totaling_html = function(html) {
        var $totaling = $checkout_pricing.find('.totaling');

        $totaling.html(html);

        _init_discount_remove_listeners();
    };

    $(document).ready(_init);

    return {};

})(jQuery);

module.exports = checkout_pricing;